/** @format */

function hasQuery(name = null) {
  return !name ? Object.keys(this.state.queries).length > 0 : this.state.queries[name] || false;
}

export { hasQuery };
